const api = {
	// url its the server sided api, change it to client url (REACT_APP_CLIENT_URL) to use the local api instead

	//url: process.env.REACT_APP_CLIENT_URL,
	url: process.env.REACT_APP_API_URL,
	client: process.env.REACT_APP_CLIENT_URL,
};

export default api;
